import React, { useState, useMemo, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { constants } from '../../constants/constants';
import { securityFunctions } from '../../constants/securityFunctions';
import { Icountry, IcountryBE, Iuser } from '../../models';
import { getUsersActiveCountry } from '../../reducers/userReducer';
import { getActiveLocalCountry } from '../../reducers/manageUserReducer';
import { getCountries } from '../../reducers/countriesReducer';
import * as types from '../../actions/actionTypes';
import * as flags from 'country-flag-icons/react/3x2';

interface ICountrySelectorProps {
    onCountryChange?: (country: Icountry) => void;
    selectedCountry?: Icountry;
    user: Iuser;
}

// Comprehensive country flag mapping
const COUNTRY_FLAGS: { [key: string]: string } = {
    Afghanistan: '🇦🇫',
    'Åland Islands': '🇦🇽',
    Albania: '🇦🇱',
    Algeria: '🇩🇿',
    'American Samoa': '🇦🇸',
    Andorra: '🇦🇩',
    Angola: '🇦🇴',
    Anguilla: '🇦🇮',
    Antarctica: '🇦🇶',
    'Antigua and Barbuda': '🇦🇬',
    Argentina: '🇦🇷',
    Armenia: '🇦🇲',
    Aruba: '🇦🇼',
    Australia: '🇦🇺',
    Austria: '🇦🇹',
    Azerbaijan: '🇦🇿',
    Bahamas: '🇧🇸',
    Bahrain: '🇧🇭',
    Bangladesh: '🇧🇩',
    Barbados: '🇧🇧',
    Belarus: '🇧🇾',
    Belgium: '🇧🇪',
    Belize: '🇧🇿',
    Benin: '🇧🇯',
    Bermuda: '🇧🇲',
    Bhutan: '🇧🇹',
    Bolivia: '🇧🇴',
    'Bonaire, Sint Eustatius and Saba': '🇧🇶',
    'Bosnia and Herzegovina': '🇧🇦',
    Botswana: '🇧🇼',
    'Bouvet Island': '🇧🇻',
    Brazil: '🇧🇷',
    'British Indian Ocean Territory': '🇮🇴',
    'Brunei Darussalam': '🇧🇳',
    Bulgaria: '🇧🇬',
    'Burkina Faso': '🇧🇫',
    Burundi: '🇧🇮',
    'Cabo Verde': '🇨🇻',
    Cambodia: '🇰🇭',
    Cameroon: '🇨🇲',
    Canada: '🇨🇦',
    'Cayman Islands': '🇰🇾',
    'Central African Republic': '🇨🇫',
    Chad: '🇹🇩',
    Chile: '🇨🇱',
    China: '🇨🇳',
    'Christmas Island': '🇨🇽',
    'Cocos (Keeling) Islands': '🇨🇨',
    Colombia: '🇨🇴',
    Comoros: '🇰🇲',
    Congo: '🇨🇬',
    'Congo, Democratic Republic of the': '🇨🇩',
    'Cook Islands': '🇨🇰',
    'Costa Rica': '🇨🇷',
    "Côte d'Ivoire": '🇨🇮',
    Croatia: '🇭🇷',
    Cuba: '🇨🇺',
    Curaçao: '🇨🇼',
    Cyprus: '🇨🇾',
    'Czech Republic': '🇨🇿',
    Denmark: '🇩🇰',
    Djibouti: '🇩🇯',
    Dominica: '🇩🇲',
    'Dominican Republic': '🇩🇴',
    Ecuador: '🇪🇨',
    Egypt: '🇪🇬',
    'El Salvador': '🇸🇻',
    'Equatorial Guinea': '🇬🇶',
    Eritrea: '🇪🇷',
    Estonia: '🇪🇪',
    Ethiopia: '🇪🇹',
    'Falkland Islands (Malvinas)': '🇫🇰',
    'Faroe Islands': '🇫🇴',
    Fiji: '🇫🇯',
    Finland: '🇫🇮',
    France: '🇫🇷',
    'French Guiana': '🇬🇫',
    'French Polynesia': '🇵🇫',
    'French Southern Territories': '🇹🇫',
    Gabon: '🇬🇦',
    Gambia: '🇬🇲',
    Georgia: '🇬🇪',
    Germany: '🇩🇪',
    Ghana: '🇬🇭',
    Gibraltar: '🇬🇮',
    Greece: '🇬🇷',
    Greenland: '🇬🇱',
    Grenada: '🇬🇩',
    Guadeloupe: '🇬🇵',
    Guam: '🇬🇺',
    Guatemala: '🇬🇹',
    Guernsey: '🇬🇬',
    Guinea: '🇬🇳',
    'Guinea-Bissau': '🇬🇼',
    Guyana: '🇬🇾',
    Haiti: '🇭🇹',
    'Heard Island and McDonald Islands': '🇭🇲',
    'Holy See (the)': '🇻🇦',
    Honduras: '🇭🇳',
    'Hong Kong': '🇭🇰',
    Hungary: '🇭🇺',
    Iceland: '🇮🇸',
    India: '🇮🇳',
    Indonesia: '🇮🇩',
    'Iran (Islamic Republic of)': '🇮🇷',
    Iraq: '🇮🇶',
    Ireland: '🇮🇪',
    'Isle of Man': '🇮🇲',
    Israel: '🇮🇱',
    Italy: '🇮🇹',
    Jamaica: '🇯🇲',
    Japan: '🇯🇵',
    Jersey: '🇯🇪',
    Jordan: '🇯🇴',
    Kazakhstan: '🇰🇿',
    Kenya: '🇰🇪',
    Kiribati: '🇰🇮',
    "Korea (Democratic People's Republic of)": '🇰🇵',
    'Korea, Republic of': '🇰🇷',
    Kosovo: '🇽🇰',
    Kuwait: '🇰🇼',
    Kyrgyzstan: '🇰🇬',
    "Lao People's Democratic Republic": '🇱🇦',
    Latvia: '🇱🇻',
    Lebanon: '🇱🇧',
    Lesotho: '🇱🇸',
    Liberia: '🇱🇷',
    Libya: '🇱🇾',
    Liechtenstein: '🇱🇮',
    Lithuania: '🇱🇹',
    Luxembourg: '🇱🇺',
    Macao: '🇲🇴',
    'Macedonia, The former Yugoslav Republic of': '🇲🇰',
    Madagascar: '🇲🇬',
    Malawi: '🇲🇼',
    Malaysia: '🇲🇾',
    Maldives: '🇲🇻',
    Mali: '🇲🇱',
    Malta: '🇲🇹',
    'Marshall Islands': '🇲🇭',
    Martinique: '🇲🇶',
    Mauritania: '🇲🇷',
    Mauritius: '🇲🇺',
    Mayotte: '🇾🇹',
    Mexico: '🇲🇽',
    'Micronesia (Federated States of)': '🇫🇲',
    'Moldova, Republic of': '🇲🇩',
    Monaco: '🇲🇨',
    Mongolia: '🇲🇳',
    Montenegro: '🇲🇪',
    Montserrat: '🇲🇸',
    Morocco: '🇲🇦',
    Mozambique: '🇲🇿',
    Myanmar: '🇲🇲',
    Namibia: '🇳🇦',
    Nauru: '🇳🇷',
    Nepal: '🇳🇵',
    Netherlands: '🇳🇱',
    'Netherlands Antilles': '🇳🇱',
    'New Caledonia': '🇳🇨',
    'New Zealand': '🇳🇿',
    Nicaragua: '🇳🇮',
    Niger: '🇳🇪',
    Nigeria: '🇳🇬',
    Niue: '🇳🇺',
    'Norfolk Island': '🇳🇫',
    'Northern Mariana Islands': '🇲🇵',
    Norway: '🇳🇴',
    Oman: '🇴🇲',
    Pakistan: '🇵🇰',
    Palau: '🇵🇼',
    'Palestine, State of': '🇵🇸',
    Panama: '🇵🇦',
    'Papua New Guinea': '🇵🇬',
    Paraguay: '🇵🇾',
    Peru: '🇵🇪',
    Philippines: '🇵🇭',
    Pitcairn: '🇵🇳',
    Poland: '🇵🇱',
    Portugal: '🇵🇹',
    'Puerto Rico': '🇵🇷',
    Qatar: '🇶🇦',
    Réunion: '🇷🇪',
    Romania: '🇷🇴',
    'Russian Federation': '🇷🇺',
    Rwanda: '🇷🇼',
    'Saint Barthélemy': '🇧🇱',
    'Saint Helena, Ascension and Tristan da Cunha': '🇸🇭',
    'Saint Kitts and Nevis': '🇰🇳',
    'Saint Lucia': '🇱🇨',
    'Saint Martin (French part)': '🇲🇫',
    'Saint Pierre and Miquelon': '🇵🇲',
    'Saint Vincent and the Grenadines': '🇻🇨',
    Samoa: '🇼🇸',
    'San Marino': '🇸🇲',
    'Sao Tome and Principe': '🇸🇹',
    'Saudi Arabia': '🇸🇦',
    Senegal: '🇸🇳',
    Serbia: '🇷🇸',
    Seychelles: '🇸🇨',
    'Sierra Leone': '🇸🇱',
    Singapore: '🇸🇬',
    'Sint Maarten (Dutch part)': '🇸🇽',
    Slovakia: '🇸🇰',
    Slovenia: '🇸🇮',
    'Solomon Islands': '🇸🇧',
    Somalia: '🇸🇴',
    'South Africa': '🇿🇦',
    'South Georgia and the South Sandwich Islands': '🇬🇸',
    'South Sudan': '🇸🇸',
    Spain: '🇪🇸',
    'Sri Lanka': '🇱🇰',
    Sudan: '🇸🇩',
    Suriname: '🇸🇷',
    'Svalbard and Jan Mayen': '🇸🇯',
    Swaziland: '🇸🇿',
    Sweden: '🇸🇪',
    Switzerland: '🇨🇭',
    'Syrian Arab Republic': '🇸🇾',
    'Taiwan, Province of China': '🇹🇼',
    Tajikistan: '🇹🇯',
    'Tanzania, United Republic of': '🇹🇿',
    Thailand: '🇹🇭',
    'Timor-Leste': '🇹🇱',
    Togo: '🇹🇬',
    Tokelau: '🇹🇰',
    Tonga: '🇹🇴',
    'Trinidad and Tobago': '🇹🇹',
    Tunisia: '🇹🇳',
    Turkey: '🇹🇷',
    Turkmenistan: '🇹🇲',
    'Turks and Caicos Islands': '🇹🇨',
    Tuvalu: '🇹🇻',
    Uganda: '🇺🇬',
    Ukraine: '🇺🇦',
    'United Arab Emirates': '🇦🇪',
    'United Kingdom': '🇬🇧',
    'United States Minor Outlying Islands': '🇺🇲',
    'United States of America': '🇺🇸',
    Uruguay: '🇺🇾',
    Uzbekistan: '🇺🇿',
    Vanuatu: '🇻🇺',
    Venezuela: '🇻🇪',
    'Viet Nam': '🇻🇳',
    'Virgin Islands (British)': '🇻🇬',
    'Virgin Islands (U.S.)': '🇻🇮',
    'Wallis and Futuna': '🇼🇫',
    'Western Sahara': '🇪🇭',
    Yemen: '🇾🇪',
    Zambia: '🇿🇲',
    Zimbabwe: '🇿🇼'
};

// Component to render country flag from code
const FlagIcon: React.FC<{ countryCode?: string; className?: string }> = ({
    countryCode,
    className = ''
}) => {
    if (!countryCode || countryCode.length !== 2) {
        // Fallback globe emoji for countries without valid code
        return <span className={className}>🌍</span>;
    }

    const code = countryCode.toUpperCase();

    const FlagComponent = (flags as any)[code];

    if (!FlagComponent) {
        // Fallback for unsupported country codes
        return <span className={className}>🌍</span>;
    }

    return (
        <FlagComponent
            className={className}
            style={{ width: '1em', height: '1em', display: 'inline-block' }}
        />
    );
};

// Union type for countries (backend or static)
type CountryUnion = IcountryBE | Icountry;

// Type guard to check if country is backend type
const isBackendCountry = (country: CountryUnion): country is IcountryBE => {
    // Check for required properties unique to backend countries
    // Backend has 'id' and 'name', frontend has 'value' and 'label'
    return 'id' in country && 'name' in country;
};

// Get country name from either type
const getCountryName = (country: CountryUnion): string => {
    return isBackendCountry(country) ? country.name : country.label;
};

// Get country ID from either type
const getCountryId = (country: CountryUnion): string => {
    return isBackendCountry(country) ? country.id : country.value;
};

// Convert backend country to frontend format for compatibility
const backendToFrontend = (country: IcountryBE): Icountry => {
    return {
        value: country.id,
        RegionID: country.regionID,
        label: country.name,
        Currency: country.currency
    };
};

const CountrySelector: React.FC<ICountrySelectorProps> = ({
    onCountryChange,
    selectedCountry,
    user
}) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [focusedIndex, setFocusedIndex] = useState<number | null>(null);
    const [lastKeyPressed, setLastKeyPressed] = useState<string | null>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const itemRefs = useRef<(HTMLButtonElement | null)[]>([]);

    // Use Redux selectors for active country (following ManageJob pattern)
    const usersActiveCountry = useSelector(getUsersActiveCountry);
    const usersActiveLocalCountry = useSelector(getActiveLocalCountry);
    const backendCountries = useSelector(getCountries);

    // Create ID translation map: static country ID -> backend country ID (by matching names)
    const idTranslationMap = useMemo((): Map<string, string> => {
        const map = new Map<string, string>();

        if (backendCountries.length === 0) {
            return map; // No translation needed when using static countries
        }

        // Helper to normalize country names for comparison
        const normalizeName = (name: string): string => {
            return name
                .toLowerCase()
                .trim()
                .replace(/[^\w\s]/g, '') // Remove punctuation
                .replace(/\s+/g, ' '); // Normalize whitespace
        };

        // Map static country IDs to backend IDs by matching country names
        Object.values(constants.countries).forEach(staticCountry => {
            const staticName = staticCountry.label;

            // Try exact match first
            let matchingBackendCountry = backendCountries.find(
                bc => bc.name === staticName
            );

            // If no exact match, try normalized comparison
            if (!matchingBackendCountry) {
                const normalizedStaticName = normalizeName(staticName);
                matchingBackendCountry = backendCountries.find(
                    bc => normalizeName(bc.name) === normalizedStaticName
                );
            }

            if (matchingBackendCountry) {
                map.set(staticCountry.value, matchingBackendCountry.id);
            }
        });

        return map;
    }, [backendCountries]);

    // Translate user's assigned country IDs from static to backend format
    const translatedUserCountries = useMemo((): string[] => {
        const userCountries = user.userCountries || [];

        if (backendCountries.length === 0) {
            return userCountries; // No translation needed
        }

        // Translate static IDs to backend IDs, filtering out unmatched entries
        const translated: string[] = [];
        const unmatchedCountries: string[] = [];

        userCountries.forEach(staticId => {
            const backendId = idTranslationMap.get(staticId);
            if (backendId) {
                translated.push(backendId);
            } else {
                // Log countries that couldn't be matched for debugging
                const staticCountry = constants.countries[staticId];
                if (staticCountry) {
                    unmatchedCountries.push(staticCountry.label);
                }
            }
        });

        // Warn about unmatched countries so they can be investigated
        if (unmatchedCountries.length > 0) {
            console.warn(
                'CountrySelector: Unable to match the following user countries with backend data:',
                unmatchedCountries,
                'These countries will not be available in the selector.'
            );
        }

        return translated;
    }, [user.userCountries, idTranslationMap, backendCountries]);

    // Filter countries based on user's AllowAllCountries security function
    const countriesArray = useMemo((): CountryUnion[] => {
        const hasAllCountriesAccess = constants.hasSecurityFunction(user, [
            securityFunctions.AllowAllCountries.id
        ]);

        // Use backend countries if available, fallback to static countries
        let allCountries: CountryUnion[];
        if (backendCountries.length > 0) {
            allCountries = backendCountries;
        } else {
            allCountries = Object.values(constants.countries);
        }

        // If user has AllowAllCountries security function, show all countries
        // Otherwise, only show assigned countries
        const availableCountries = hasAllCountriesAccess
            ? allCountries
            : allCountries.filter(country =>
                  translatedUserCountries.includes(getCountryId(country))
              );

        // Sort countries: assigned ones first, then alphabetically within each group
        return availableCountries.sort((a, b) => {
            const aIsAssigned = translatedUserCountries.includes(
                getCountryId(a)
            );
            const bIsAssigned = translatedUserCountries.includes(
                getCountryId(b)
            );

            // If both are assigned or both are unassigned, sort alphabetically
            if (aIsAssigned === bIsAssigned) {
                return getCountryName(a).localeCompare(getCountryName(b));
            }

            // Assigned countries come first
            return bIsAssigned ? 1 : -1;
        });
        // eslint-disable-next-line
    }, [user.securityFunctions, backendCountries, translatedUserCountries]);

    // Get active country following ManageJob pattern - prioritize local over global
    const getActiveCountry = (): string => {
        if (usersActiveLocalCountry !== '') {
            return usersActiveLocalCountry;
        } else {
            return usersActiveCountry;
        }
    };

    // Save selected country using Redux action
    const saveSelectedCountry = (countryId: string) => {
        dispatch({
            type: types.UPDATE_USER_LOCAL_COUNTRY,
            payload: countryId
        });
    };

    // Use the default country from constants or backend
    const defaultCountry = useMemo((): CountryUnion | undefined => {
        // Translate default country ID from static to backend format if needed
        const defaultCountryId =
            backendCountries.length > 0
                ? idTranslationMap.get(constants.defaultCountryID) ||
                  constants.defaultCountryID
                : constants.defaultCountryID;

        // First try to find default country in filtered countriesArray (user has permission)
        const defaultInFiltered = countriesArray.find(
            c => getCountryId(c) === defaultCountryId
        );
        if (defaultInFiltered) {
            return defaultInFiltered;
        }
        // Fallback to first country user has access to
        return countriesArray[0];
    }, [countriesArray, backendCountries, idTranslationMap]);

    // Get the current active country from Redux state
    const activeCountryId = getActiveCountry();
    const activeCountry = useMemo((): CountryUnion | undefined => {
        // Translate active country ID from static to backend format if needed
        const translatedActiveId =
            backendCountries.length > 0
                ? idTranslationMap.get(activeCountryId) || activeCountryId
                : activeCountryId;

        // Only return active country if user has permission to access it
        return countriesArray.find(c => getCountryId(c) === translatedActiveId);
    }, [activeCountryId, countriesArray, backendCountries, idTranslationMap]);

    // Validate selected country prop - only use if user has permission to access it
    const validatedSelectedCountry = useMemo((): CountryUnion | undefined => {
        if (!selectedCountry) return undefined;

        // Get selected country ID and translate if needed
        const selectedId = getCountryId(selectedCountry);
        const translatedSelectedId =
            backendCountries.length > 0
                ? idTranslationMap.get(selectedId) || selectedId
                : selectedId;

        // Check if selected country exists in filtered array (user has permission)
        return countriesArray.find(
            c => getCountryId(c) === translatedSelectedId
        );
    }, [selectedCountry, countriesArray, backendCountries, idTranslationMap]);

    // Priority: 1. Active country from Redux, 2. Validated selected country prop, 3. Default country
    const currentCountry: CountryUnion | undefined =
        activeCountry || validatedSelectedCountry || defaultCountry;

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleCountrySelect = (country: CountryUnion) => {
        // Save to Redux state using UPDATE_USER_LOCAL_COUNTRY action
        saveSelectedCountry(getCountryId(country));
        // Notify parent component - convert to Icountry format for compatibility
        if (onCountryChange) {
            const frontendCountry = isBackendCountry(country)
                ? backendToFrontend(country)
                : country;
            onCountryChange(frontendCountry);
        }
        setIsOpen(false);
    };

    // Get SAP country code from country object
    const getCountryCode = (
        country: CountryUnion | undefined
    ): string | undefined => {
        if (!country) return undefined;

        // Try SAP code first (backend countries)
        if (isBackendCountry(country) && country.sapCountryCode) {
            return country.sapCountryCode;
        }

        // Fallback to looking up code from COUNTRY_FLAGS mapping for static countries
        // This is for backward compatibility with static data
        const name = getCountryName(country);
        const flagEmoji = COUNTRY_FLAGS[name];
        if (flagEmoji && flagEmoji !== '🌍') {
            // Convert flag emoji back to country code using proper code point handling
            // Regional Indicator symbols are pairs of code points in range U+1F1E6 to U+1F1FF
            try {
                const codePoints: number[] = [];
                // Use Array.from to properly handle surrogate pairs
                for (const char of Array.from(flagEmoji)) {
                    const point = char.codePointAt(0);
                    if (point) {
                        codePoints.push(point);
                    }
                }

                // Should have exactly 2 regional indicator symbols
                if (codePoints.length === 2) {
                    const code = codePoints
                        .map(point => String.fromCodePoint(point - 127397))
                        .join('');
                    return code;
                }
            } catch (error) {
                // If emoji parsing fails, return undefined
                console.warn('Failed to parse flag emoji for country:', name);
            }
        }

        return undefined;
    };

    // Helper function to find next matching country by letter
    const findNextMatchingCountry = (
        letter: string,
        currentIndex: number | null,
        shouldCycle: boolean
    ): number | null => {
        const normalizedLetter = letter.toLowerCase();

        if (shouldCycle && currentIndex !== null) {
            // When cycling, only search forward from current position (no wrap)
            for (let i = currentIndex + 1; i < countriesArray.length; i++) {
                if (
                    getCountryName(countriesArray[i])
                        .toLowerCase()
                        .startsWith(normalizedLetter)
                ) {
                    return i;
                }
            }
            // If no match found after current, wrap to beginning
            for (let i = 0; i <= currentIndex; i++) {
                if (
                    getCountryName(countriesArray[i])
                        .toLowerCase()
                        .startsWith(normalizedLetter)
                ) {
                    return i;
                }
            }
        } else {
            // Fresh search - find first match in entire list
            for (let i = 0; i < countriesArray.length; i++) {
                if (
                    getCountryName(countriesArray[i])
                        .toLowerCase()
                        .startsWith(normalizedLetter)
                ) {
                    return i;
                }
            }
        }

        return null;
    };

    // Handle keyboard navigation
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (!isOpen) return;

        const key = event.key;

        // Handle Escape key - close dropdown
        if (key === 'Escape') {
            event.preventDefault();
            setIsOpen(false);
            return;
        }

        // Handle Enter key
        if (key === 'Enter' && focusedIndex !== null) {
            event.preventDefault();
            handleCountrySelect(countriesArray[focusedIndex]);
            return;
        }

        // Handle arrow keys
        if (key === 'ArrowDown' || key === 'ArrowUp') {
            event.preventDefault();

            let newIndex: number;
            if (focusedIndex === null) {
                // If nothing focused, start at beginning (ArrowDown) or end (ArrowUp)
                newIndex = key === 'ArrowDown' ? 0 : countriesArray.length - 1;
            } else {
                // Move up or down
                if (key === 'ArrowDown') {
                    newIndex =
                        focusedIndex < countriesArray.length - 1
                            ? focusedIndex + 1
                            : 0; // Wrap to beginning
                } else {
                    newIndex =
                        focusedIndex > 0
                            ? focusedIndex - 1
                            : countriesArray.length - 1; // Wrap to end
                }
            }

            setFocusedIndex(newIndex);

            // Scroll the focused item into view
            if (itemRefs.current[newIndex]) {
                itemRefs.current[newIndex]?.scrollIntoView({
                    block: 'nearest',
                    behavior: 'instant' as ScrollBehavior,
                    inline: 'center'
                });
            }

            // Clear letter navigation state when using arrows
            setLastKeyPressed(null);
            return;
        }

        // Only handle single letter keys
        if (key.length !== 1 || !/[a-zA-Z]/.test(key)) {
            return;
        }

        event.preventDefault();
        const normalizedKey = key.toLowerCase();

        // Check if same key pressed (cycling behavior)
        const isCycling = lastKeyPressed === normalizedKey;

        const nextIndex = findNextMatchingCountry(
            normalizedKey,
            focusedIndex,
            isCycling
        );

        // Always update lastKeyPressed, even if no match found
        setLastKeyPressed(normalizedKey);

        if (nextIndex !== null) {
            setFocusedIndex(nextIndex);

            // Scroll the focused item into view
            if (itemRefs.current[nextIndex]) {
                itemRefs.current[nextIndex]?.scrollIntoView({
                    block: 'nearest',
                    behavior: 'instant' as ScrollBehavior,
                    inline: 'center'
                });
            }
        }
    };

    // Handle clicking outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    // Reset focused index when dropdown closes
    useEffect(() => {
        if (!isOpen) {
            setFocusedIndex(null);
            setLastKeyPressed(null);
        }
    }, [isOpen]);

    // Auto-focus the menu when it opens
    useEffect(() => {
        if (isOpen && menuRef.current) {
            menuRef.current.focus();
        }
    }, [isOpen]);

    return (
        <div className="header-country-selector" ref={dropdownRef}>
            <button
                className="country-selector-toggle"
                onClick={toggleDropdown}
                type="button"
            >
                <FlagIcon
                    countryCode={getCountryCode(currentCountry)}
                    className="country-flag"
                />
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`chevron ${isOpen ? 'chevron-up' : ''}`}
                />
            </button>

            {isOpen && (
                <div
                    className="country-selector-menu"
                    ref={menuRef}
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                >
                    <div className="country-menu-items">
                        {countriesArray.map((country, index) => {
                            const countryId = getCountryId(country);
                            const isAssigned = translatedUserCountries.includes(
                                countryId
                            );
                            const isSelected =
                                currentCountry &&
                                getCountryId(currentCountry) === countryId;
                            const isFocused = focusedIndex === index;

                            return (
                                <button
                                    key={countryId}
                                    ref={el => (itemRefs.current[index] = el)}
                                    type="button"
                                    className={`country-menu-item ${
                                        isSelected ? 'selected' : ''
                                    } ${
                                        isAssigned ? 'assigned' : 'unassigned'
                                    } ${isFocused ? 'focused' : ''}`}
                                    onClick={() => handleCountrySelect(country)}
                                >
                                    <FlagIcon
                                        countryCode={getCountryCode(country)}
                                        className="country-flag"
                                    />
                                    <span
                                        className={`country-name ${
                                            isAssigned ? 'assigned' : ''
                                        }`}
                                    >
                                        {getCountryName(country)}
                                        {isBackendCountry(country) &&
                                            country.sapCountryCode &&
                                            ` (${country.sapCountryCode})`}
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CountrySelector;
